function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#666",
  d: "M0 0h1.5v32H0zM13 17h1.5v14H13zM28.5 0H30v32h-1.5z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#666",
  d: "M0 30.5h30V32H0zM19.211 0h10.105v1.5H19.211zM22.578 16h6.737v1.5h-6.737zM7.578 16h10.105v1.5H7.578zM1 0h11v1.5H1z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#666",
  d: "M12 0l6.065 4.521-.908 1.219-6.065-4.521z"
});

function SvgFloorplanIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default SvgFloorplanIcon;